module.exports = __webpack_public_path__ + "static/media/tram.597f0b7f.svg";